
export default {
    state: {
        search_term: null,
        search_results: []
    },

    mutations: {
        setSearchTerm(state, data) {
            state.search_term = data;
        },

        setSearchResults(state, data) {
            state.search_results = data;
        },

        resetSearch(state) {
            state.search_term = null;
            state.search_results = [];
        },
    },

    actions: {
        getSearchResults({ state, getters, commit, rootState }, term) {
            commit('setSearchTerm', term);

            // search for articles
            let articles = rootState.articles.list.filter((item) => {
                let active_subscription = item.subscriptions.includes(rootState.subscriptions.active_subscription.id),
                    title = item.name.toLowerCase(),
                    match = title.includes(term.toLowerCase()),
                    isNotHidden = !item.hide_in_list,
                    isArticle = !item.is_category;
                
                const parent = getters.getArticleGroup(item.parent_topic);
                if (parent) {
                    item.parent = parent.name;
                }
                    
                return active_subscription && match && isNotHidden && isArticle;
            });

            // search for documents
            let documents = rootState.documents.list.filter((document) => {
                let active_subscription = document.subscriptions.includes(rootState.subscriptions.active_subscription.id),
                    title = document.name.toLowerCase(),
                    match = title.includes(term.toLowerCase());
                
                return active_subscription && match;
            });

            let items = articles.concat(documents);

            // search for fixtures
            let fixtures = rootState.fixtures.fixtures_list.filter((fixture) => {
                let active_subscription = fixture.subscriptions.includes(rootState.subscriptions.active_subscription.id),
                    type = fixture.type_name = rootState.fixtures.fixture_types.filter((type) => {
                        return type.id === fixture.type;
                    })[0].name,
                    title = type.toLowerCase(),
                    match = title.includes(term.toLowerCase());
                
                fixture.name = type;
                
                return active_subscription && match;
            });

            items = items.concat(fixtures);

            // sort by order
            items.sort((a, b) => {
                return a.order - b.order;
            });

            // further sort alphabetically by order
            items.sort((a, b) => {
                let comparison = 0;

                if (a.name > b.name) {
                    comparison = 1;
                } else {
                    comparison = -1;
                }

                return comparison;
            });

            commit('setSearchResults', items);
        }
    }
};